import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    0%{
        opacity: 0;
        transform: translateY(20px);
        height: calc(100% - 20px);
    }
    100%{
        opacity: 1;
        transform: translateY(0);
        height:100%;
    }
`;
export const StyleWrapper = styled.section`
  animation: ${fadeIn} 0.3s;
  display: inherit;
  width: 100%;
  height: 100%;
`;
